import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsStop2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m3.501-11.501H4.5V11.5h7z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsStop2
